import * as Sentry from '@sentry/react';

const dsn = process.env['NX_PUBLIC_SENTRY_DSN'];
const environment = process.env['NX_PUBLIC_SENTRY_ENV'];

if (!dsn) {
  console.warn('Sentry DSN not found. Sentry will not be initialized.');
} else {
  try {
    Sentry.init({
      dsn,
      environment,
      sendDefaultPii: true,
      tracesSampleRate: 0.1, // Reduced from 1.0 to 10%
      replaysSessionSampleRate: 0.01, // Reduced from 0.1 to 1%
      replaysOnErrorSampleRate: 0.1, // Reduced from 1.0 to 10%
      integrations: [
        Sentry.replayIntegration({
          maskAllText: true,
          maskAllInputs: true,
          blockAllMedia: true,
        }),
      ],
    });
  } catch (error) {
    console.error('Failed to initialize Sentry:', error);
  }
}
